import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=515da4dc&lang=pug"
import script from "./AppLoading.vue?vue&type=script&lang=ts"
export * from "./AppLoading.vue?vue&type=script&lang=ts"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=515da4dc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports